<template>
  <div class="order-details">
    <template>
      <div class="bg">
        <div class="bgwrite">
          <div class="bgcon">
            <div class="cjtitle">请填写物流信息</div>
            <div class="cjtime" v-if="status == 1">
              请在{{ orderInfo.check_time }}前填写物流信息
            </div>
          </div>
          <div class="nav" style="background-color: transparent;">
            <div
              class="progress acea-row row-between-wrapper"
              style="margin-bottom: 20px;"
            >
              <!-- <div
                class="iconfont"
                :class="[
                  status === 0 ? 'icon-webicon318' : 'icon-yuandianxiao',
                  status >= 0 ? 'font-color-red' : ''
                ]"
              ></div>
              <div
                class="line"
                :class="{ 'bg-color-red': status > 0 }"
              ></div> -->
              <div
                class="iconfont"
                :class="[
                  status === 0 ? 'icon-webicon318' : 'icon-yuandianxiao',
                  status >= 0 ? 'font-color-red' : ''
                ]"
              ></div>
              <div
                class="line"
                :class="{
                  'bg-color-red': status > 0
                }"
              ></div>
              <div
                class="iconfont icon-yuandianxiao"
                :class="[
                  status === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
                  status >= 1 ? 'font-color-red' : ''
                ]"
              ></div>
              <div
                class="line"
                :class="{
                  'bg-color-red': status > 1
                }"
              ></div>
              <div
                class="iconfont icon-yuandianxiao"
                :class="[
                  status === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
                  status >= 2 ? 'font-color-red' : ''
                ]"
              ></div>
              <div
                class="line"
                :class="{
                  'bg-color-red': status > 2
                }"
              ></div>
              <div
                class="iconfont icon-yuandianxiao"
                :class="[status == 3 ? 'icon-webicon318' : 'icon-yuandianxiao']"
              ></div>
            </div>
            <div class="navCon acea-row row-between-wrapper">
              <!-- <div :class="{ on: status === 0 }">提交申请</div> -->
              <div :class="{ on: status === 0 }">商家处理</div>
              <div :class="{ on: status === 1 }">寄回商品</div>
              <div :class="{ on: status === 2 }" v-if="apply_type == 0">
                商家退款
              </div>
              <div :class="{ on: status === 3 }" v-if="apply_type == 0">
                退款成功
              </div>
              <div :class="{ on: status === 2 }" v-if="apply_type == 1">
                商家发货
              </div>
              <div :class="{ on: status === 3 }" v-if="apply_type == 1">
                换货成功
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"><img src="@assets/images/line.jpg" /></div>
      <div class="box" v-if="apply_type == 0 && status == 0">
        您已成功发出退款申请，请耐心等待商家处理
      </div>
      <div class="box" v-if="apply_type == 1 && status == 0">
        您已成功发出退货申请，请耐心等待商家处理
      </div>
      <div class="box" v-if="apply_type == 0 && status == -1">
        您的退款申请，已被商家拒绝
        <div class="boxword">拒绝原因：{{ orderInfo.fail_reason }}</div>
      </div>
      <div class="box" v-if="apply_type == 1 && status == -1">
        您的退货申请，已被商家拒绝
        <div class="boxword">拒绝原因：{{ orderInfo.fail_reason }}</div>
      </div>
    </template>
    <OrderGoods
      :recedetype="status"
      :applytype="apply_type"
      :cartInfo="orderInfo.cartInfo || []"
      :oid="orderInfo.id"
      :id="$route.query.id"
    ></OrderGoods>
  </div>
</template>
<script>
import OrderGoods from "@components/OrderGoods";
import { orderReturns, orderReturnsClose } from "@api/order";
export default {
  components: {
    OrderGoods
  },
  props: {},
  data: function() {
    return {
      orderInfo: [],
      status: 0,
      apply_type: 0
    };
  },
  mounted: function() {
    console.log(this.$route.query.id);
    orderReturns({ id: this.$route.query.id }).then(res => {
      console.log(res);
      this.orderInfo = res.data;
      this.status = res.data.status;
      this.apply_type = res.data.apply_type;
      var remindTime = res.data.check_time;

      if (res.data.status == 1) {
        var str = remindTime.toString();
        str = str.replace("/-/g", "/");
        var oldTime = new Date(str).getTime();
        if (oldTime <= new Date().getTime()) {
          console.log(111);
          orderReturnsClose({ id: this.$route.query.id }).then(res => {
            console.log(res);
            this.$dialog.toast({ mes: "退换货申请时间超时" });
            this.$router.go(-1);
            return;
          });
        }
      }
    });
  },
  methods: {}
};
</script>
<style>
.box {
  width: 100%;
  height: auto;
  padding: 15px;
  background: #fff;
  box-sizing: border-box;
  line-height: 30px;
  font-size: 15px;
  font-weight: bold;
}
.boxword {
  font-weight: 100;
  font-size: 14px;
}
.bg {
  background-color: #00c049;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.bgwrite {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  border-radius: 5px;
}
.bgcon {
  width: 100%;
  height: 100%;
  padding: 15px;
  padding-bottom: 0;
  box-sizing: border-box;
}
.bgcon .cjtitle {
  font-size: 15px;
  font-weight: bold;
  line-height: 35px;
}
.bgcon .cjtime {
  color: #999999;
  font-size: 14px;
  line-height: 35px;
}
</style>
